<template>
  <div class="flex items-center justify-center w-full h-full">
    <t-loader-circle v-if="isLoading === true" />
    <qrcode-stream
      @init="
        useReady($event)
        $emit('init', $event)
      "
      @decode="$emit('decode', $event)"
      ref="QRScanner"
      v-show="isLoading === false && permissionErrorType === null"
      style="width: calc(100% - 2rem)"
      :camera="camera"
      class="aspect-[1/1] h-unset rounded-md overflow-hidden"
    />
    <div v-if="isLoading === false && permissionErrorType !== null">
      <t-text color="black" class="flex w-full text-center" size="xl">{{ $t(`components.camera.${permissionErrorType}`) }}</t-text>
    </div>
  </div>
</template>

<script>
  export default {
    name: 't-camera',
    data() {
      return {
        isLoading: true,
        permissionErrorType: null,
        camera: 'off'
      }
    },
    mounted() {
      this.camera = 'auto'
    },
    beforeDestroy() {
      this.camera = 'off'
    },
    methods: {
      useReady(promise) {
        promise
          .catch(error => {
            this.permissionErrorType = error.name
            // if (error.name === 'NotAllowedError') {
            //   // user denied camera access permisson
            // } else if (error.name === 'NotFoundError') {
            //   // no suitable camera device installed
            // } else if (error.name === 'NotSupportedError') {
            //   // page is not served over HTTPS (or localhost)
            // } else if (error.name === 'NotReadableError') {
            //   // maybe camera is already in use
            // } else if (error.name === 'OverconstrainedError') {
            //   // did you requested the front camera although there is none?
            // } else if (error.name === 'StreamApiNotSupportedError') {
            //   // browser seems to be lacking features
            // }
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
</script>
